import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';

import { MarketsComponent } from './markets/markets.component';
import { MarketparamComponent } from './markets/marketparam/marketparam.component';

// import { environment } from '../../environments/environment'; // Not used in SEO anymore...
import { MarketsModule } from './markets.module';

const routes: Routes = [
  {
    path: 'markets',
    component: MarketsComponent,
    data: {
      title: 'Cryptocurrency Market Exchange South Africa: Crypto Markets',
      meta: {
        title: 'Cryptocurrency Market Exchange South Africa: Crypto Markets',
        description: 'Cryptocurrency Market Exchange South Africa: Crypto Markets. Buy, sell & trade Bitcoin, Ethereum & other digital assets with ZAR. Cryptocurrency Markets in SA.',
        'og:image': 'https://chainex.io/assets/chainex/images/meta/Markets.png',
        'twitter:image': 'https://chainex.io/assets/chainex/images/meta/Markets.png',
        'twitter:card': 'summary_large_image'
      }
    },
    children: [
      { path: ':coin1/:coin2', component: MarketparamComponent },
    ],
    canActivate: [MetaGuard]
  }
];

export const routing: ModuleWithProviders<MarketsModule> = RouterModule.forChild(routes);
